import { Box, Button, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import type { TimetableFormat } from '@timetable/types';
import type { WizardState, WizardAction } from '../ImportWizard';

interface Step4Props {
  state: WizardState;
  dispatch: React.Dispatch<WizardAction>;
  onNext: (patch?: Record<string, unknown>) => Promise<void>;
  onBack: () => void;
}

const FORMAT_OPTIONS: { value: TimetableFormat; label: string; description: string }[] = [
  {
    value: 'single',
    label: 'Single Excel for all classes',
    description: 'One workbook with a separate sheet per class.',
  },
  {
    value: 'per-class',
    label: 'One Excel per class',
    description: 'A separate workbook for each class.',
  },
];

export function Step4TimetableFormat({ state, dispatch, onNext, onBack }: Step4Props) {
  const canAdvance = state.timetableFormat !== null;

  const handleNext = async () => {
    await onNext({ timetable_format: state.timetableFormat });
  };

  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h6">Step 4: Timetable Template Format</Typography>
      <Typography variant="body2" color="text.secondary">
        Choose the format for the timetable template download.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2 }}>
        {FORMAT_OPTIONS.map((opt) => (
          <Card
            key={opt.value}
            variant="outlined"
            sx={{
              flex: 1,
              borderColor: state.timetableFormat === opt.value ? 'primary.main' : 'divider',
              borderWidth: state.timetableFormat === opt.value ? 2 : 1,
            }}
          >
            <CardActionArea
              onClick={() => dispatch({ type: 'SET_TIMETABLE_FORMAT', payload: opt.value })}
              sx={{ height: '100%', p: 1 }}
            >
              <CardContent>
                <Typography variant="subtitle1" fontWeight={600}>
                  {opt.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {opt.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" disabled={!canAdvance} onClick={handleNext}>
          Next
        </Button>
      </Box>
    </Box>
  );
}
